import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { FaArrowRight, FaCalendarAlt } from "react-icons/fa";

export default function OneGallery({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    if (appContext && appContext.navTo) {
      appContext.navTo({
        item: 'view',
        subItem: 'gallery',
        extraItem: data.uuid,
      });
    }
  }

  // Chagua picha sahihi: Ikiwa ni static (ina coverPhoto moja kwa moja) au kutoka API (data.photo)
  const imageSrc = data.coverPhoto 
    ? data.coverPhoto 
    : (data.photo ? (data.photo.startsWith('http') ? data.photo : CDN_URL + data.photo) : "");

  return (
    <div 
      className="card ycsc-gallery-card border-0 rounded-4 overflow-hidden shadow-sm mb-4"
      onClick={view}
    >
      {/* PICHA YA NYUMA YA KADI */}
      <div 
        className="gallery-card-bg"
        style={{ backgroundImage: `url(${imageSrc})` }}
      />
      
      {/* GRADIENT OVERLAY */}
      <div className="gallery-card-overlay" />

      {/* MAELEZO NA KATEGORIA JUU YA KADI */}
      <div className="gallery-card-content d-flex flex-column justify-content-between p-4">
        
        {/* KATEGORIA (BADGE) */}
        <div className="align-self-start">
          {/* {data.category && (
            <span className="badge bg-warning text-dark text-uppercase px-3 py-2 rounded-pill small fw-bold tracking-wider">
              {data.category}
            </span>
          )} */}
        </div>

        {/* MAELEZO YA CHINI */}
        <div className="gallery-card-bottom">
          <h5 className="gallery-card-title text-white fw-bold mb-2">
            {data.title || data.description}
          </h5>
          
          <div className="d-flex align-items-center justify-content-between text-light-muted mt-2 pt-2 border-top border-secondary-subtle">
            <div className="d-flex align-items-center gap-2 small">
              <FaCalendarAlt className="text-warning-dim" />
              <span>{data.dateCreated || "2026"}</span>
            </div>
            <span className="gallery-view-link small d-flex align-items-center gap-1 text-warning fw-semibold">
              <span>Tazama</span>
              <FaArrowRight className="view-arrow" />
            </span>
          </div>
        </div>

      </div>
    </div>
  );
}